import cn from 'classnames';
import styles from './Textarea.module.css';

type Props = React.ComponentPropsWithRef<'textarea'> & {
  className?: string;
  hasError?: boolean;
  /** Allow the textarea to be resized by the user */
  resizable?: 'horizontal' | 'vertical' | 'both';
  /** Number of columns */
  cols?: number;
  /** Number of rows */
  rows?: number;
};

export function Textarea({ hasError, resizable, className, cols = 40, rows = 3, ...htmlProps }: Props) {
  const resizeClass = resizable ? styles[`Textarea___${resizable}Resizable`] : '';

  const classes = cn('border-focusable', styles.Textarea, resizeClass, className, {
    'has-error': hasError,
  });

  return <textarea className={classes} aria-invalid={hasError} cols={cols} rows={rows} {...htmlProps} />;
}
